module.exports = __webpack_public_path__ + "kusamaproject/img/selected.4c7678d5.png";